export enum VatType {
    NO_VAT = 0,
    INCLUDE_VAT = 1,
    EXCLUDE_VAT = 2,
}
